import { render, staticRenderFns } from "./detail_info.vue?vue&type=template&id=c3610a78&scoped=true&"
import script from "./detail_info.vue?vue&type=script&lang=js&"
export * from "./detail_info.vue?vue&type=script&lang=js&"
import style0 from "./detail_info.vue?vue&type=style&index=0&id=c3610a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3610a78",
  null
  
)

export default component.exports